exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".liTerms___1wf9Y {\n  margin: 0 !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n}\n", "", {"version":3,"sources":["/home/jenkins/agent/workspace/causefundraisernodeweb-ci-release/public/js/components/donation-terms.less"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,6BAA6B;CAC9B","file":"donation-terms.less","sourcesContent":[".liTerms {\n  margin: 0 !important;\n  font-size: 14px !important;\n  line-height: 20px !important;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"liTerms": "liTerms___1wf9Y"
};